module.exports = __webpack_public_path__ + "img/history-hanging.abfad581.svg";